"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[48530,39559,12274],{

/***/ 816519:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A": function() { return /* binding */ Glide; }
/* harmony export */ });
/* harmony import */ var _glidejs_glide__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(490400);
/* harmony import */ var _teko_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(593859);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(891987);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(212951);





var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const Glide = (0,react__WEBPACK_IMPORTED_MODULE_1__.forwardRef)((_a, ref) => {
  var _b = _a, {
    className,
    children,
    onSlideChange,
    style,
    showControl = true,
    showBullet = false,
    trackingArrowRight,
    trackingArrowLeft,
    customStyleLeftArrow,
    customStyleRightArrow,
    displayNewLayout
  } = _b, glideOpts = __objRest(_b, [
    "className",
    "children",
    "onSlideChange",
    "style",
    "showControl",
    "showBullet",
    "trackingArrowRight",
    "trackingArrowLeft",
    "customStyleLeftArrow",
    "customStyleRightArrow",
    "displayNewLayout"
  ]);
  const newRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
  const childRefs = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)([]);
  const chooseRef = ref || newRef;
  const opts = __spreadValues(__spreadValues({}, defaultGlideOptions), glideOpts);
  if (children.length === 1) {
    opts.autoplay = false;
    showBullet = false;
    showControl = false;
  }
  (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(() => {
    if (typeof chooseRef === "function" || !chooseRef.current)
      return;
    const controller = new _glidejs_glide__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z(chooseRef.current, opts);
    let mounted;
    if (onSlideChange) {
      controller.on("move.after", () => {
        mounted && onSlideChange(mounted.index);
      });
    }
    (0,_teko_utils__WEBPACK_IMPORTED_MODULE_3__/* .scheduleTaskInIdleTime */ .D_)(() => {
      mounted = controller.mount();
      children.length === 1 && (mounted == null ? void 0 : mounted.disable());
      if (chooseRef.current) {
        chooseRef.current.glide = mounted;
      }
    }, 3e3);
    return () => mounted == null ? void 0 : mounted.destroy();
  }, [children.length]);
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_1__.createElement(Wrapper, {
    ref: chooseRef,
    className: `${className || ""} glide`,
    style,
    displayNewLayout
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_1__.createElement("div", {
    className: "glide__track",
    "data-glide-el": "track"
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_1__.createElement("div", {
    className: "glide__slides"
  }, react__WEBPACK_IMPORTED_MODULE_1__.Children.map(children, (child, index) => {
    var _a2, _b2, _c;
    return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_1__.createElement("div", {
      ref: (e) => childRefs.current[index] = e,
      key: child.key || index,
      className: "glide__slide",
      style: {
        height: "unset",
        marginRight: index < children.length - 1 ? ((_a2 = childRefs.current[index]) == null ? void 0 : _a2.style.marginRight) || 5 : 0,
        marginLeft: index > 0 ? ((_b2 = childRefs.current[index]) == null ? void 0 : _b2.style.marginLeft) || 5 : 0,
        width: ((_c = childRefs.current) == null ? void 0 : _c[0]) ? childRefs.current[0].style.width : `calc(100% / ${opts.perView} - 8px) `
      }
    }, child);
  }))), showControl && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_1__.createElement("div", {
    "data-glide-el": "controls",
    className: "glide__arrows"
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_1__.createElement("div", __spreadValues({
    className: "glide__arrow--override glide__arrow--left",
    "data-glide-dir": `${opts.perSwipe ? "|" : ""}<`,
    style: customStyleLeftArrow
  }, trackingArrowLeft)), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_1__.createElement("div", __spreadValues({
    className: "glide__arrow--override glide__arrow--right",
    "data-glide-dir": `${opts.perSwipe ? "|" : ""}>`,
    style: customStyleRightArrow
  }, trackingArrowRight))), showBullet && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_1__.createElement("div", {
    className: "glide__bullets glide__bullets--override",
    "data-glide-el": "controls[nav]"
  }, react__WEBPACK_IMPORTED_MODULE_1__.Children.map(children, (_, index) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_1__.createElement("button", {
    className: "glide__bullet",
    key: index,
    "data-glide-dir": `=${index}`
  }))));
});
Glide.displayName = "Glide";
const Wrapper = _emotion_styled__WEBPACK_IMPORTED_MODULE_2__["default"].div((props) => `
  &:hover {
    .glide__arrow--override {
      visibility: visible;
    }
  }

  .glide__track {
    overflow: hidden;
    position: relative;
    height: 100%;
  }
  .glide__slides {
    height: 100%;
  }
  .glide__arrow--override {
    position: absolute;
    left: 0;
    top: 50%;
    z-index: 10;
    cursor: pointer;
    display: flex;
    -webkit-box-align: center;
    align-items: center;
    -webkit-box-pack: center;
    justify-content: center;
    width: 44px;
    height: 44px;
    transform: translateY(-50%);
    background-color: rgba(168, 168, 168, 0.46);
    visibility: hidden;
  }

  .glide__arrow--left {
    right: auto;
    left: 0;
    border-top-right-radius: 100px;
    border-bottom-right-radius: 100px;

    &:after {
      mask: url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTE1LjUgNUw4LjUgMTJMMTUuNSAxOSIgc3Ryb2tlPSIjODI4NjlFIiBzdHJva2Utd2lkdGg9IjEuNSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+Cjwvc3ZnPgo=');
      content: ' ';
      height: 30px;
      width: 30px;
      mask-size: contain;
      display: inline-block;
      background: #333;
    }
  }

  .glide__arrow--right {
    right: 0;
    left: auto;
    border-top-left-radius: 100px;
    border-bottom-left-radius: 100px;

    &:after {
      mask: url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTguNSAxOUwxNS41IDEyTDguNSA1IiBzdHJva2U9IiM4Mjg2OUUiIHN0cm9rZS13aWR0aD0iMS41IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPC9zdmc+Cg==');
      content: ' ';
      height: 30px;
      width: 30px;
      mask-size: contain;
      display: inline-block;
      background: #333;
    }
  }

  ${props.displayNewLayout ? `.glide__arrow--override {
    visibility: visible;
    width: 28px;
    height: 28px;
  }
  .horizontal-slider,
  .glide__track {
    margin: 0 auto;
    background-color: white;
  }
  .glide__slides {
    margin: 0 auto;
  }
  .glide__arrow--left {
    left: 8px !important;
    border-radius: 100px;
    background-color: #fff !important;
    box-shadow: -1px 4px 5px 2px rgba(0, 0, 0, 0.12);
    &:after {
      height: 14px !important;
      width: 14px !important;
      box-shadow: 0px 9px 28px 8px rgba(0, 0, 0, 0.05);
      box-shadow: 0px 3px 6px -4px rgba(0, 0, 0, 0.12);
      box-shadow: 0px 6px 16px 0px rgba(0, 0, 0, 0.08);
    }
  }
  .glide__arrow--right {
    right: 8px !important;
    border-radius: 100px;
    background-color: #fff !important;
    box-shadow: -1px 4px 5px 2px rgba(0, 0, 0, 0.12);
    &:after {
      height: 14px !important;
      width: 14px !important;
      box-shadow: 0px 9px 28px 8px rgba(0, 0, 0, 0.05);
      box-shadow: 0px 3px 6px -4px rgba(0, 0, 0, 0.12);
      box-shadow: 0px 6px 16px 0px rgba(0, 0, 0, 0.08);
    }
  }` : ``}
`);
const defaultGlideOptions = {
  type: "slider",
  startAt: 0,
  perView: 2.3,
  perSwipe: "",
  focusAt: 0,
  gap: 10,
  autoplay: false,
  hoverpause: true,
  keyboard: true,
  bound: false,
  swipeThreshold: 80,
  dragThreshold: 120,
  perTouch: false,
  touchRatio: 0.5,
  touchAngle: 45,
  animationDuration: 400,
  rewind: false,
  rewindDuration: 800,
  animationTimingFunc: "cubic-bezier(0.165, 0.840, 0.440, 1.000)",
  direction: "ltr",
  peek: 0,
  breakpoints: {},
  throttle: 25
};




/***/ }),

/***/ 248169:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "R": function() { return /* binding */ InputNumber; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);
/* harmony import */ var rc_input_number__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(241305);
/* harmony import */ var _Typography_index_es_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(621655);
/* harmony import */ var _teko_ds_icon__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(994734);
/* harmony import */ var _teko_ds_icon__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(925810);
/* harmony import */ var _Shape_index_es_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(425336);
/* harmony import */ var _constants_index_es_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(978719);
/* harmony import */ var _contexts_SizeContext_es_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(263008);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(212951);









var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SAVED_DECIMAL_SEPARATOR = ".";
const InputNumber = react__WEBPACK_IMPORTED_MODULE_0__.forwardRef((_a, ref) => {
  var _b = _a, {
    size: customizeSize,
    addonBefore,
    addonAfter,
    bordered = true,
    disabled = false,
    readOnly = false,
    formatter,
    parser
  } = _b, props = __objRest(_b, [
    "size",
    "addonBefore",
    "addonAfter",
    "bordered",
    "disabled",
    "readOnly",
    "formatter",
    "parser"
  ]);
  var _a2, _b2;
  const size = react__WEBPACK_IMPORTED_MODULE_0__.useContext(_contexts_SizeContext_es_js__WEBPACK_IMPORTED_MODULE_3__/* .SizeContext */ .X);
  const mergeSize = customizeSize || size || "m";
  const { decimalSeparator } = props;
  const defaultFormatter = (value) => {
    if (!value)
      return "";
    if (typeof value === "string") {
      value = parseFloat(value);
    }
    const locale = decimalSeparator === "." ? "en-CA" : "de-DE";
    return new Intl.NumberFormat(locale, {
      maximumFractionDigits: 10
    }).format(value);
  };
  const defaultParser = (value) => {
    if (!value) {
      return "";
    }
    const thousandSeparator = decimalSeparator === "." ? "," : ".";
    return value.replace(thousandSeparator, "").replace(decimalSeparator || ".", SAVED_DECIMAL_SEPARATOR);
  };
  const prefix = addonBefore ? /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledSpace, {
    height: _constants_index_es_js__WEBPACK_IMPORTED_MODULE_4__/* .MAPPING_SIZE */ .v[mergeSize]
  }, typeof addonBefore === "string" ? /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Typography_index_es_js__WEBPACK_IMPORTED_MODULE_5__/* .Body */ .uT, {
    color: "textSecondary",
    level: 1,
    weight: "regular"
  }, addonBefore) : react__WEBPACK_IMPORTED_MODULE_0__.cloneElement(addonBefore, {
    size: ((_a2 = addonBefore == null ? void 0 : addonBefore.props) == null ? void 0 : _a2.size) || 20
  })) : null;
  const suffix = addonAfter ? /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledSpace, {
    height: _constants_index_es_js__WEBPACK_IMPORTED_MODULE_4__/* .MAPPING_SIZE */ .v[mergeSize],
    marginLeft: "s16"
  }, typeof addonAfter === "string" ? /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Typography_index_es_js__WEBPACK_IMPORTED_MODULE_5__/* .Body */ .uT, {
    color: "textSecondary",
    level: 1,
    weight: "regular"
  }, addonAfter) : react__WEBPACK_IMPORTED_MODULE_0__.cloneElement(addonAfter, {
    size: ((_b2 = addonAfter == null ? void 0 : addonAfter.props) == null ? void 0 : _b2.size) || 20
  })) : null;
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Wrapper, {
    height: _constants_index_es_js__WEBPACK_IMPORTED_MODULE_4__/* .MAPPING_SIZE */ .v[mergeSize],
    disabled,
    readOnly,
    bordered,
    paddingRight: !!suffix ? "s16" : "s0",
    className: "wrap-input-number"
  }, prefix, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(rc_input_number__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, __spreadValues({
    ref,
    upHandler: /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_icon__WEBPACK_IMPORTED_MODULE_6__/* .UpOutlined */ .X, {
      size: 12
    }),
    downHandler: /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_icon__WEBPACK_IMPORTED_MODULE_7__/* .DownOutlined */ .T, {
      size: 12
    }),
    disabled,
    readOnly,
    formatter: formatter != null ? formatter : defaultFormatter,
    parser: parser != null ? parser : defaultParser
  }, props)), suffix);
});
InputNumber.displayName = "InputNumber";
const Wrapper = (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_2__["default"])(_Shape_index_es_js__WEBPACK_IMPORTED_MODULE_8__/* .Shape */ .b)(({ theme, disabled, readOnly, bordered }) => `
  ${disabled ? `background: ${theme == null ? void 0 : theme.colors.background}; 
         cursor: not-allowed;` : "background: white;"}
  ${bordered ? `border: 1px solid ${theme == null ? void 0 : theme.colors.border};
         border-radius: 4px;` : ""}
  &:focus-within{
    border-color: ${theme == null ? void 0 : theme.colors.link500};
  }
  display: flex;
  padding-left: 0.75rem;
  .rc-input-number {
      position: relative;
      flex: 1;
      padding: 0 1px;
      &:hover{
        .rc-input-number-handler-wrap{
            opacity: 1;
        }
      }
  }
  .rc-input-number-input-wrap{
      height: 100%;
      & input {
        width: 100%;
        height: 100%;
        outline: 0;
        border: 0;
        &::placeholder {
          color: ${theme == null ? void 0 : theme.colors.placeholder};
        }
        ${disabled ? "cursor: not-allowed;" : ""}
    }
  }
  .rc-input-number-handler-wrap{
      opacity: 0;
      transition: opacity 0.24s linear 0.1s;
      position: absolute;
      display: flex;
      flex-direction: column;
      justify-content: center;
      right: 0;
      line-height: 0;
      height: 100%;
      width: 25px;
      ${bordered ? `border-left: 1px solid ${theme == null ? void 0 : theme.colors.border};
             border-right: 1px solid ${theme == null ? void 0 : theme.colors.border};` : ""}
      ${disabled || readOnly ? "display: none;" : ""}
  }
  .rc-input-number-handler-up, 
  .rc-input-number-handler-down{
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    &:hover path {
      stroke: ${theme == null ? void 0 : theme.colors.link500};
    }
  }
  .rc-input-number-handler-down {
    ${bordered ? `border-top: 1px solid ${theme == null ? void 0 : theme.colors.border};` : ""}
  }
  .rc-input-number-handler-up-disabled, 
  .rc-input-number-handler-down-disabled {
    cursor: not-allowed;
    background: ${theme == null ? void 0 : theme.colors.background};
    &:hover path {
      stroke: ${theme == null ? void 0 : theme.colors.textSecondary};
    }
  }
`);
const StyledSpace = (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_2__["default"])(_Shape_index_es_js__WEBPACK_IMPORTED_MODULE_8__/* .Shape */ .b)`
  display: flex;
  align-items: center;
`;




/***/ }),

/***/ 280392:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "h": function() { return /* binding */ Quantity; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);
/* harmony import */ var _constants_index_es_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(978719);
/* harmony import */ var _teko_ds_icon__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(957518);
/* harmony import */ var _teko_ds_icon__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(873834);
/* harmony import */ var _BaseProps_index_es_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(640128);
/* harmony import */ var _InputNumber_InputNumber_es_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(248169);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(212951);







var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const QuantitySize = {
  xs: {
    height: _constants_index_es_js__WEBPACK_IMPORTED_MODULE_2__/* .CORE_SIZE.s28 */ .y.s28,
    width: "5.75rem"
  },
  s: {
    height: _constants_index_es_js__WEBPACK_IMPORTED_MODULE_2__/* .CORE_SIZE.s32 */ .y.s32,
    width: "6.375rem"
  },
  m: {
    height: _constants_index_es_js__WEBPACK_IMPORTED_MODULE_2__/* .CORE_SIZE.s40 */ .y.s40,
    width: "6.375rem"
  }
};
const QuantityWrapper = _emotion_styled__WEBPACK_IMPORTED_MODULE_1__["default"].div((props) => {
  var _a, _b, _c, _d, _e, _f;
  return [
    _BaseProps_index_es_js__WEBPACK_IMPORTED_MODULE_3__/* .CommonStyles */ .F,
    `
  height: ${QuantitySize[props.size || "m"].height};
  width: ${props.block ? "100%" : QuantitySize[props.size || "m"].width};
  border-radius: ${(_a = props.theme) == null ? void 0 : _a.borderRadius.s};
  background: ${props.disabled ? (_b = props.theme) == null ? void 0 : _b.colors.background : (_c = props.theme) == null ? void 0 : _c.colors.tableHeader};
  ${!props.disabled ? `border: ${(_d = props.theme) == null ? void 0 : _d.borderWeight.m} solid ${((_e = props.theme) == null ? void 0 : _e.colors[props.color]) || ((_f = props.theme) == null ? void 0 : _f.colors.divider)};` : ""}
  display: flex;
  align-items: center;
  overflow: hidden;
`
  ];
});
const Plus = _emotion_styled__WEBPACK_IMPORTED_MODULE_1__["default"].button(({ disabled }) => `
    height: 100%;
    width: 2rem;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    user-select: none;
    border: none;
    background: transparent;
    &:focus {
      outline: none;
    }
    ${disabled ? "cursor: not-allowed;" : ""}
`);
const Minus = _emotion_styled__WEBPACK_IMPORTED_MODULE_1__["default"].button(({ disabled }) => `
    height: 100%;
    width: 2rem;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    user-select: none;
    border: none;
    background: transparent;
    &:focus {
      outline: none;
    }
    ${disabled ? "cursor: not-allowed;" : ""}
`);
const InputWrapper = _emotion_styled__WEBPACK_IMPORTED_MODULE_1__["default"].div(({ color, theme }) => `
  flex: 1;
  .wrap-input-number {
    padding: 0;
    border: none;
    background-color: transparent;
  }
  .wrap-input-number input {
    text-align: center;
    background-color: transparent;
    font-size: 0.8125rem;
    font-weight: 500;
    color: ${color ? (theme == null ? void 0 : theme.colors[color]) || color : "rgb(67, 70, 87)"};
  }
`);
const IconButonWapper = _emotion_styled__WEBPACK_IMPORTED_MODULE_1__["default"].span`
  display: inline-flex;
  align-items: center;
`;
const Quantity = (_a) => {
  var _b = _a, {
    min = 1,
    max = 999,
    quantity = 1,
    precision,
    decimalSeparator = ",",
    step = 1,
    size = "s",
    disabled,
    disableInput,
    disableMinus,
    disablePlus,
    className,
    onMinus,
    onPlus,
    setQuantity,
    color,
    block,
    blurOnEnter = false,
    formatter,
    parser
  } = _b, rest = __objRest(_b, [
    "min",
    "max",
    "quantity",
    "precision",
    "decimalSeparator",
    "step",
    "size",
    "disabled",
    "disableInput",
    "disableMinus",
    "disablePlus",
    "className",
    "onMinus",
    "onPlus",
    "setQuantity",
    "color",
    "block",
    "blurOnEnter",
    "formatter",
    "parser"
  ]);
  const inputRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
  const onChange = (val) => {
    if (typeof val === "string") {
      val = parseFloat(val);
    }
    if (typeof val !== "number") {
      return;
    }
    setQuantity == null ? void 0 : setQuantity(val);
  };
  const onDecrease = () => {
    if (onMinus) {
      onMinus();
    } else if (step) {
      setQuantity == null ? void 0 : setQuantity(quantity - step);
    }
  };
  const onIncrease = () => {
    if (onPlus) {
      onPlus();
    } else if (step) {
      setQuantity == null ? void 0 : setQuantity(quantity + step);
    }
  };
  const disableMinusButton = disabled || disableMinus || quantity - step < min;
  const disablePlusButton = disabled || disablePlus || quantity + step > max;
  const disableInputField = disabled || disableInput;
  const handleBlurOnEnter = (e) => {
    var _a2;
    const ENTER_CHAR_CODE = 13;
    if (e.charCode === ENTER_CHAR_CODE) {
      (_a2 = inputRef.current) == null ? void 0 : _a2.blur();
    }
  };
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    const current = inputRef.current;
    if (blurOnEnter) {
      current == null ? void 0 : current.addEventListener("keypress", handleBlurOnEnter);
    }
    return () => {
      current == null ? void 0 : current.removeEventListener("keypress", handleBlurOnEnter);
    };
  }, [blurOnEnter]);
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(QuantityWrapper, __spreadValues({
    className,
    size,
    block,
    disabled,
    color,
    onClick: (e) => e.preventDefault()
  }, rest), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Minus, {
    className: "minus-btn",
    disabled: disableMinusButton,
    onClick: onDecrease,
    color
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(IconButonWapper, null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_icon__WEBPACK_IMPORTED_MODULE_4__/* .MinusOutlined */ .l, {
    color: disableMinusButton ? "disable" : color || "textPrimary",
    size: 16
  }))), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(InputWrapper, {
    className: "quantity-input-wrapper",
    color
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_InputNumber_InputNumber_es_js__WEBPACK_IMPORTED_MODULE_5__/* .InputNumber */ .R, {
    ref: inputRef,
    value: quantity,
    onFocus: (event) => event.target.select(),
    onChange,
    disabled: disableInputField,
    controls: false,
    min,
    max,
    step,
    precision,
    decimalSeparator,
    formatter,
    parser
  })), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Plus, {
    className: "plus-btn",
    disabled: disablePlusButton,
    onClick: onIncrease,
    color
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(IconButonWapper, null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_icon__WEBPACK_IMPORTED_MODULE_6__/* .AddOutlined */ .v, {
    color: disablePlusButton ? "disable" : color || "textPrimary",
    size: 16
  }))));
};




/***/ }),

/***/ 991822:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "V": function() { return /* binding */ Tag; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);
/* harmony import */ var _Typography_index_es_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(621655);
/* harmony import */ var _BaseProps_index_es_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(640128);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(212951);





var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const MAPPING_COLOR_500 = {
  branding: "primary500",
  link: "link500",
  success: "success500",
  error: "error500",
  pending: "pending500"
};
const MAPPING_COLOR_600 = {
  branding: "primary600",
  link: "link600",
  success: "success600",
  error: "error600",
  pending: "pending600"
};
const MAPPING_COLOR_50 = {
  branding: "primary50",
  link: "link50",
  success: "success50",
  error: "error50",
  pending: "pending50"
};
const Wrapper = _emotion_styled__WEBPACK_IMPORTED_MODULE_1__["default"].span`
  ${_BaseProps_index_es_js__WEBPACK_IMPORTED_MODULE_2__/* .CommonStyles */ .F}
  display: inline-flex;
  align-items: center;
  padding-left: ${(p) => p.theme.spacing.s4};
  padding-right: ${(p) => p.theme.spacing.s4};
  height: 1rem;
  border-radius: ${(p) => p.theme.borderRadius.s};
  border: ${(p) => p.borderColor ? `${p.theme.borderWeight.m} solid ${p.theme.colors[p.borderColor]}` : "unset"};
  background-color: ${(p) => p.theme.colors[p.backgroundColor]};
`;
const Tag = (_a) => {
  var _b = _a, {
    variant = "branding",
    type = "primary",
    content,
    className
  } = _b, rest = __objRest(_b, [
    "variant",
    "type",
    "content",
    "className"
  ]);
  const getBgColor = () => {
    if (type === "primary") {
      if (variant === "default")
        return "white";
      return MAPPING_COLOR_500[variant];
    }
    if (type === "secondary") {
      if (variant === "default")
        return "background";
      return MAPPING_COLOR_50[variant];
    }
    if (type === "ghost") {
      return "white";
    }
  };
  const getBorderColor = () => {
    if (type === "ghost") {
      if (variant === "default")
        return "border";
      return MAPPING_COLOR_600[variant];
    }
  };
  const getColor = () => {
    if (variant === "default")
      return "textPrimary";
    if (type === "primary")
      return "white";
    return MAPPING_COLOR_600[variant];
  };
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Wrapper, __spreadValues({
    backgroundColor: getBgColor() || "",
    borderColor: getBorderColor(),
    className
  }, rest), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Typography_index_es_js__WEBPACK_IMPORTED_MODULE_3__/* .Caption */ .YS, {
    color: getColor(),
    level: 3,
    weight: "medium",
    line: 1
  }, content));
};




/***/ }),

/***/ 873834:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "v": function() { return /* binding */ AddOutlined; }
/* harmony export */ });
/* harmony import */ var _helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(404334);


const AddOutlined = (props) => {
  return (0,_helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__/* .GenIcon */ .w_)({
    tag: "svg",
    attr: { viewBox: "0 0 24 24", fill: "none" },
    child: [
      {
        tag: "path",
        attr: {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M12.75 4C12.75 3.58579 12.4142 3.25 12 3.25C11.5858 3.25 11.25 3.58579 11.25 4V11.25H4C3.58579 11.25 3.25 11.5858 3.25 12C3.25 12.4142 3.58579 12.75 4 12.75H11.25V20C11.25 20.4142 11.5858 20.75 12 20.75C12.4142 20.75 12.75 20.4142 12.75 20V12.75H20C20.4142 12.75 20.75 12.4142 20.75 12C20.75 11.5858 20.4142 11.25 20 11.25H12.75V4Z",
          fill: "#82869E"
        }
      }
    ]
  })(props);
};




/***/ }),

/***/ 925810:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "T": function() { return /* binding */ DownOutlined; }
/* harmony export */ });
/* harmony import */ var _helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(404334);


const DownOutlined = (props) => {
  return (0,_helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__/* .GenIcon */ .w_)({
    tag: "svg",
    attr: { viewBox: "0 0 24 24", fill: "none" },
    child: [
      {
        tag: "path",
        attr: {
          d: "M5 8.5L12 15.5L19 8.5",
          stroke: "#82869E",
          strokeWidth: "1.5",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      }
    ]
  })(props);
};




/***/ }),

/***/ 994734:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "X": function() { return /* binding */ UpOutlined; }
/* harmony export */ });
/* harmony import */ var _helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(404334);


const UpOutlined = (props) => {
  return (0,_helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__/* .GenIcon */ .w_)({
    tag: "svg",
    attr: { viewBox: "0 0 24 24", fill: "none" },
    child: [
      {
        tag: "path",
        attr: {
          d: "M19 15.5L12 8.5L5 15.5",
          stroke: "#82869E",
          strokeWidth: "1.5",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      }
    ]
  })(props);
};




/***/ }),

/***/ 980424:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "H": function() { return /* binding */ NoProductsFound; }
/* harmony export */ });
/* harmony import */ var _i18n_es_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(334751);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);
/* harmony import */ var _teko_ui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(855271);
/* harmony import */ var _teko_ui__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(179185);




var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const Wrapper = _teko_ui__WEBPACK_IMPORTED_MODULE_1__/* .styled.div */ .z.div`
  margin-top: 8rem;
  text-align: center;
`;
const Text = _teko_ui__WEBPACK_IMPORTED_MODULE_1__/* .styled.div */ .z.div`
  margin-top: 1.5rem;
  font-size: 1rem;
`;
const NoProductsFound = (_a) => {
  var _b = _a, {
    text = (0,_i18n_es_js__WEBPACK_IMPORTED_MODULE_2__.t)("Kh\xF4ng t\xECm th\u1EA5y s\u1EA3n ph\u1EA9m n\xE0o"),
    show
  } = _b, props = __objRest(_b, [
    "text",
    "show"
  ]);
  const NoProductImage = "https://firebasestorage.googleapis.com/v0/b/mongcaifood.appspot.com/o/no-products-found.png?alt=media&token=2f22ae28-6d48-49a7-a36b-e1a696618f9c";
  if (!show)
    return null;
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Wrapper, __spreadValues({}, props), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ui__WEBPACK_IMPORTED_MODULE_3__/* .LazyImage */ .w, {
    width: 200,
    height: 200,
    contain: true,
    src: NoProductImage
  }), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Text, null, text));
};




/***/ }),

/***/ 788925:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "N": function() { return /* binding */ EnhancedImage; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(587021);
/* harmony import */ var _TekoLink_TekoLink_es_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(675601);




var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const EnhancedImage = (props) => {
  const _a = props, { link, tracking } = _a, rest = __objRest(_a, ["link", "tracking"]);
  const img = /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_1__/* .Image */ .E, __spreadValues(__spreadValues({}, rest), !!tracking ? { tracking } : {}));
  return (link == null ? void 0 : link.href) ? /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_TekoLink_TekoLink_es_js__WEBPACK_IMPORTED_MODULE_2__/* .TekoLink */ .A, __spreadValues({}, link), img) : img;
};




/***/ }),

/***/ 784241:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "r": function() { return /* binding */ HorizontalSlider; }
/* harmony export */ });
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(212951);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(640128);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);



var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const HorizontalSlider = (_a) => {
  var _b = _a, {
    slidesPerView,
    children
  } = _b, props = __objRest(_b, [
    "slidesPerView",
    "children"
  ]);
  if (!Array.isArray(children)) {
    return null;
  }
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Wrapper, __spreadValues({}, props), Array.isArray(children) && children.map((item, index) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Item, {
    slidesPerView,
    key: index
  }, item)));
};
const Wrapper = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_1__["default"].div(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_2__/* .CommonStyles */ .F, () => `
  display: flex;
  width: 100%;
  overflow-x: scroll;
  overflow-y: hidden;
  -webkit-overflow-scrolling: touch;
  -ms-overflow-style: none;
  &::-webkit-scrollbar {
    display: none;
  };
  transform: translate3d(0,0,0);
  `);
const Item = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_1__["default"].div((props) => {
  var _a;
  return `
    width: ${100 / ((_a = props.slidesPerView) != null ? _a : 1)}%;
    flex-shrink: 0;
    margin-right: 8px;
  `;
});




/***/ }),

/***/ 414562:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "G": function() { return /* binding */ ProductCarousel; }
/* harmony export */ });
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(816519);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(212951);
/* harmony import */ var _teko_tracking__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(77322);
/* harmony import */ var _teko_tracking__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(428247);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);
/* harmony import */ var _HorizontalSlider_HorizontalSlider_es_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(784241);
/* harmony import */ var _contexts_DeviceContext_es_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(917709);
/* harmony import */ var _ProductCard_ProductCard_es_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(922859);







var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const ProductCarousel = (_a) => {
  var _b = _a, {
    products = [],
    productsPerRow,
    className,
    regionName,
    hideCtaButton,
    border,
    customStyleLeftArrow,
    customStyleRightArrow,
    desktopProps
  } = _b, props = __objRest(_b, [
    "products",
    "productsPerRow",
    "className",
    "regionName",
    "hideCtaButton",
    "border",
    "customStyleLeftArrow",
    "customStyleRightArrow",
    "desktopProps"
  ]);
  const { isMobile } = (0,_contexts_DeviceContext_es_js__WEBPACK_IMPORTED_MODULE_1__/* .useDevice */ .F)();
  const trackViewProductListData = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(() => {
    return products.map((product) => {
      var _a2, _b2;
      return {
        sku: product.sku || "",
        category: ((_b2 = (_a2 = product.categories) == null ? void 0 : _a2[0]) == null ? void 0 : _b2.name) || ""
      };
    });
  }, [products]);
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    if (trackViewProductListData.length > 0) {
      (0,_teko_tracking__WEBPACK_IMPORTED_MODULE_2__/* .trackViewProductList */ .u)(trackViewProductListData);
    }
  }, [JSON.stringify(trackViewProductListData)]);
  if (isMobile) {
    return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
      className: "wrapper-horizontal-slider"
    }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_HorizontalSlider_HorizontalSlider_es_js__WEBPACK_IMPORTED_MODULE_3__/* .HorizontalSlider */ .r, {
      slidesPerView: productsPerRow || 2.3,
      className: "horizontal-slider"
    }, products.map((product, index) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledCard, {
      key: product.sku,
      border: !!border
    }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_ProductCard_ProductCard_es_js__WEBPACK_IMPORTED_MODULE_4__/* .ProductCard */ .I, __spreadProps(__spreadValues({}, product), {
      tracking: regionName ? (0,_teko_tracking__WEBPACK_IMPORTED_MODULE_5__/* .getTrackingData */ .O5)({
        regionName,
        isTrackContent: true,
        contentName: product.sku,
        target: "productDetail",
        index: index + 1,
        payload: product.bestComboDiscount && Number(product.bestComboDiscount) !== 0 ? JSON.stringify({ promotionType: "combo" }) : void 0
      }) : {},
      addToCart: hideCtaButton ? void 0 : product.addToCart
    }))))));
  }
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_6__/* .Glide */ .A, __spreadValues(__spreadProps(__spreadValues({
    perView: productsPerRow || 5,
    perSwipe: "|",
    className,
    customStyleLeftArrow,
    customStyleRightArrow
  }, props), {
    showControl: products.length > (productsPerRow || 5),
    swipeThreshold: products.length > (productsPerRow || 5),
    dragThreshold: products.length > (productsPerRow || 5)
  }), desktopProps), products.map((item, index) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledCard, {
    key: item.sku,
    border: !!border
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_ProductCard_ProductCard_es_js__WEBPACK_IMPORTED_MODULE_4__/* .ProductCard */ .I, __spreadProps(__spreadValues({}, item), {
    tracking: (0,_teko_tracking__WEBPACK_IMPORTED_MODULE_5__/* .getTrackingData */ .O5)({
      regionName,
      isTrackContent: true,
      contentName: item.sku,
      target: "productDetail",
      index: index + 1,
      payload: item.bestComboDiscount && Number(item.bestComboDiscount) !== 0 ? JSON.stringify({ promotionType: "combo" }) : void 0
    }),
    addToCart: hideCtaButton ? void 0 : item.addToCart
  })))));
};
const Card = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_7__["default"].div`
  background: white;
  border-radius: 0.5rem;
`;
const StyledCard = (0,_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_7__["default"])(Card)(({ theme, border }) => __spreadValues({
  height: "100%"
}, border ? {
  border: "1px solid",
  borderColor: theme.colors.divider,
  borderRadius: theme.spacing.s8,
  overflow: "hidden"
} : {}));




/***/ }),

/***/ 591007:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "j": function() { return /* binding */ ProductPrice; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(621655);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(212951);
/* harmony import */ var _helpers_number_es_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(54230);




const isShowRetailPrice = (supplierRetailPrice, latestPrice) => {
  let newSupplierRetailPrice = supplierRetailPrice;
  let newLatestPrice = latestPrice;
  if (typeof supplierRetailPrice === "string") {
    newSupplierRetailPrice = supplierRetailPrice.replace(/[₫đ.]/g, "");
  }
  if (typeof latestPrice === "string") {
    newLatestPrice = latestPrice.replace(/[₫đ.]/g, "");
  }
  return Number(newSupplierRetailPrice) > Number(newLatestPrice);
};
const ProductPrice = ({
  supplierRetailPrice,
  latestPrice,
  discountPercent,
  textColor = "primary500",
  align = "start",
  size = "m",
  className,
  priceRange,
  numberDisplayFormat
}) => {
  const formattedRetailPrice = typeof supplierRetailPrice === "number" ? (0,_helpers_number_es_js__WEBPACK_IMPORTED_MODULE_1__/* .formatCurrency */ .xG)(supplierRetailPrice, numberDisplayFormat) : supplierRetailPrice;
  const formattedLatestPrice = typeof latestPrice === "number" ? (0,_helpers_number_es_js__WEBPACK_IMPORTED_MODULE_1__/* .formatCurrency */ .xG)(latestPrice, numberDisplayFormat) : latestPrice;
  let renderedRetailPrice, renderedDiscount;
  const renderedLatestPrice = () => {
    if (!priceRange) {
      return size === "l" ? /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_2__/* .Title */ .Dx, {
        className: "att-product-detail-latest-price",
        level: 2,
        color: textColor,
        weight: "bold"
      }, formattedLatestPrice) : /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_2__/* .SubTitle */ .DK, {
        className: "att-product-detail-latest-price",
        level: 1,
        color: textColor
      }, formattedLatestPrice);
    }
    const formattedMinPrice = (0,_helpers_number_es_js__WEBPACK_IMPORTED_MODULE_1__/* .formatCurrency */ .xG)(priceRange.min, numberDisplayFormat, false);
    const formattedMaxPrice = (0,_helpers_number_es_js__WEBPACK_IMPORTED_MODULE_1__/* .formatCurrency */ .xG)(priceRange.max, numberDisplayFormat);
    return size === "l" ? /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledTitle, {
      level: 2,
      color: textColor,
      weight: "bold",
      line: 1
    }, formattedMinPrice, " - ", formattedMaxPrice) : /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledSubTitle, {
      level: 1,
      color: textColor,
      line: 1
    }, formattedMinPrice, " - ", formattedMaxPrice);
  };
  switch (size) {
    case "l":
      renderedRetailPrice = /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledRetailPrice, {
        className: "att-product-detail-retail-price",
        level: 1,
        color: "textSecondary"
      }, formattedRetailPrice);
      renderedDiscount = /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_2__/* .Caption */ .YS, {
        level: 1,
        color: "red"
      }, discountPercent);
      break;
    default:
      renderedRetailPrice = /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledRetailPrice, {
        className: "att-product-detail-retail-price",
        level: 1,
        color: "textSecondary"
      }, formattedRetailPrice);
      renderedDiscount = /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_2__/* .Caption */ .YS, {
        level: 1,
        color: "red"
      }, discountPercent);
      break;
  }
  const showRetailPrice = supplierRetailPrice && isShowRetailPrice(supplierRetailPrice, latestPrice);
  const isShowDiscount = !!discountPercent;
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(ProductPriceWrapper, {
    align,
    className
  }, renderedLatestPrice(), (showRetailPrice || isShowDiscount) && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledDiscount, null, showRetailPrice && renderedRetailPrice, isShowDiscount && renderedDiscount));
};
const ProductPriceWrapper = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_3__["default"].div(({ align }) => `
  display: flex;
  flex-direction: column;
  align-items: ${align};
  height: 2.5rem;
`);
const StyledRetailPrice = (0,_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_3__["default"])(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_2__/* .Caption */ .YS)(({ theme }) => `
    text-decoration: line-through;
    margin-right: ${theme == null ? void 0 : theme.spacing.s4};
`);
const StyledDiscount = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_3__["default"].div`
  display: flex;
  height: 1rem;
`;
const StyledTitle = (0,_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_3__["default"])(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_2__/* .Title */ .Dx)`
  word-break: break-all;
`;
const StyledSubTitle = (0,_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_3__["default"])(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_2__/* .SubTitle */ .DK)`
  word-break: break-all;
`;




/***/ }),

/***/ 675601:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A": function() { return /* binding */ TekoLink; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(535874);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(212951);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(640128);
/* harmony import */ var _teko_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(456933);
/* harmony import */ var _teko_utils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(987900);






var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const serverless = typeof window !== "undefined";
const normalizeUrl = (url) => {
  if (!serverless || !url || typeof url !== "string")
    return url;
  if (url.match(/^https?:\/\/([^/]+)/)) {
    const urlObj = new URL(url);
    if (urlObj.hostname === window.location.host) {
      return `${urlObj.pathname}${urlObj.search}`;
    }
  }
  return url;
};
const TekoLink = (_a) => {
  var _b = _a, {
    children,
    href,
    as,
    prefetch = false
  } = _b, rest = __objRest(_b, [
    "children",
    "href",
    "as",
    "prefetch"
  ]);
  const [newState, setNewState] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)({
    pathname: (typeof href === "string" ? href : href == null ? void 0 : href.pathname) || "",
    query: {},
    as
  });
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    async function init() {
      if (!href)
        return;
      href = normalizeUrl(href);
      as = normalizeUrl(as);
      if (typeof href === "string") {
        const result = await (0,_teko_utils__WEBPACK_IMPORTED_MODULE_3__/* .resolveTekoPathname */ .K)((0,_teko_utils__WEBPACK_IMPORTED_MODULE_4__/* .getUrlObject */ .Bi)(href));
        if (!result.pathname) {
          result.pathname = href;
        }
        setNewState(__spreadProps(__spreadValues({}, result), { as: as || href }));
      } else {
        const result = await (0,_teko_utils__WEBPACK_IMPORTED_MODULE_3__/* .resolveTekoPathname */ .K)(href);
        if (!result.pathname && (href == null ? void 0 : href.pathname)) {
          result.pathname = href.pathname;
        }
        setNewState(__spreadProps(__spreadValues(__spreadValues({}, href), result), {
          as: as || ((href == null ? void 0 : href.pathname) ? href : null) || void 0
        }));
      }
    }
    init();
  }, [href, as, setNewState]);
  if (!href) {
    return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, children);
  }
  if (serverless) {
    return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledLink, __spreadValues({
      "data-testid": "TekoLink",
      href: { pathname: newState.pathname, query: newState.query },
      as: newState.as,
      prefetch
    }, rest), children);
  }
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledLink, __spreadProps(__spreadValues({
    "data-testid": "TekoLink",
    href: href || "",
    as
  }, rest), {
    prefetch
  }), children);
};
const StyledLink = (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_2__["default"])((next_link__WEBPACK_IMPORTED_MODULE_1___default()))`
  ${_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_5__/* .CommonStyles */ .F}
  color: black;
  text-decoration: none;
`;




/***/ }),

/***/ 875547:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ok": function() { return /* binding */ SOURCE_VIDEO; },
/* harmony export */   "bM": function() { return /* binding */ defaultSlider; },
/* harmony export */   "n6": function() { return /* binding */ DEFAULT_NUMBER_DISPLAY_FORMAT; }
/* harmony export */ });
const defaultSlider = {
  perView: 5,
  perSwipe: "|",
  autoplay: 0
};
const DEFAULT_NUMBER_DISPLAY_FORMAT = {
  thousandSeparator: ".",
  decimalSeparator: ","
};
var SOURCE_VIDEO = /* @__PURE__ */ ((SOURCE_VIDEO2) => {
  SOURCE_VIDEO2["SYSTEM"] = "SYSTEM";
  SOURCE_VIDEO2["YOUTUBE"] = "YOUTUBE";
  return SOURCE_VIDEO2;
})(SOURCE_VIDEO || {});




/***/ }),

/***/ 54230:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "V2": function() { return /* binding */ numberFormatter; },
/* harmony export */   "kX": function() { return /* binding */ numberParser; },
/* harmony export */   "xG": function() { return /* binding */ formatCurrency; }
/* harmony export */ });
/* harmony import */ var _constants_index_es_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(875547);


const formatCurrency = (value, numberDisplayFormat, includeUnit = true) => {
  if (typeof value !== "number")
    return "";
  let currencyFormat;
  if (includeUnit)
    currencyFormat = new Intl.NumberFormat("vi-VN", {
      style: "currency",
      currency: "VND"
    });
  else
    currencyFormat = new Intl.NumberFormat("vi-VN");
  const valueWithCurrency = currencyFormat.format(value);
  if (!!numberDisplayFormat) {
    return valueWithCurrency.replaceAll(".", numberDisplayFormat.thousandSeparator);
  } else {
    return valueWithCurrency;
  }
};
const numberFormatter = (value, numberDisplayFormat) => {
  const strValue = String(value);
  const [integerPart, decimalPart = ""] = strValue.split(".");
  return integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, (numberDisplayFormat == null ? void 0 : numberDisplayFormat.thousandSeparator) || _constants_index_es_js__WEBPACK_IMPORTED_MODULE_0__/* .DEFAULT_NUMBER_DISPLAY_FORMAT.thousandSeparator */ .n6.thousandSeparator) + (strValue.includes(".") ? `${(numberDisplayFormat == null ? void 0 : numberDisplayFormat.decimalSeparator) || _constants_index_es_js__WEBPACK_IMPORTED_MODULE_0__/* .DEFAULT_NUMBER_DISPLAY_FORMAT.decimalSeparator */ .n6.decimalSeparator}${decimalPart}` : "");
};
const numberParser = (value, numberDisplayFormat) => {
  return (numberDisplayFormat == null ? void 0 : numberDisplayFormat.decimalSeparator) === "." ? `${value}`.replace(new RegExp(`[^0-9-${(numberDisplayFormat == null ? void 0 : numberDisplayFormat.decimalSeparator) || _constants_index_es_js__WEBPACK_IMPORTED_MODULE_0__/* .DEFAULT_NUMBER_DISPLAY_FORMAT.decimalSeparator */ .n6.decimalSeparator}]`, "g"), "") : `${value}`.replace(new RegExp(`[^0-9-${(numberDisplayFormat == null ? void 0 : numberDisplayFormat.decimalSeparator) || _constants_index_es_js__WEBPACK_IMPORTED_MODULE_0__/* .DEFAULT_NUMBER_DISPLAY_FORMAT.decimalSeparator */ .n6.decimalSeparator}]`, "g"), "").replace(`${(numberDisplayFormat == null ? void 0 : numberDisplayFormat.decimalSeparator) || _constants_index_es_js__WEBPACK_IMPORTED_MODULE_0__/* .DEFAULT_NUMBER_DISPLAY_FORMAT.decimalSeparator */ .n6.decimalSeparator}`, ".");
};




/***/ }),

/***/ 29921:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "A": function() { return /* binding */ NAMESPACE; },
  "K": function() { return /* binding */ lang; },
  "t": function() { return /* binding */ t; }
});

// EXTERNAL MODULE: ../../.yarn/cache/i18next-npm-21.4.0-68c8d0fefd-cd26c166df.zip/node_modules/i18next/dist/esm/i18next.js
var i18next = __webpack_require__(396556);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-teko-ecommerce-virtual-ca6c4b0024/1/packages/teko-ecommerce/dist/lang/vi.es.js
var viLang = {
	"src.components.ProductCard.ProductCard.0": "Sản phẩm này là đồ uống có cồn, quý khách cần xác nhận mình trên 18 tuổi để mua sản phẩm!"
};



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-teko-ecommerce-virtual-ca6c4b0024/1/packages/teko-ecommerce/dist/lang/en.es.js
var enLang = {
	"Kết thúc sau": "End in",
	"ngày": "day",
	"Còn {{DurationDays}} ngày": "{{DurationDays}} days left",
	"Giảm trực tiếp": "Discount",
	"Tặng": "Receive",
	"GIẢM": "Decrease",
	"Không tìm thấy sản phẩm nào": "No product found",
	"Cảnh báo": "Warning",
	"src.components.ProductCard.ProductCard.0": "This is alcohol product, please confirm you are 18 years old to purchase!",
	"Tôi trên 18 tuổi": "I am over 18",
	"Tôi dưới 18 tuổi": "I am under 18",
	"Xác nhận": "Confirm",
	"TIẾT KIỆM": "Save",
	"Xem thêm": "Expand",
	"Thu gọn": "Collapse",
	"Bộ lọc đã dùng": "Used filter",
	"Xóa bộ lọc": "Clear filter",
	"Hàng trưng bày": "Sample",
	"Hàng đặt trước": "Pre-order",
	"Ngừng kinh doanh": "Stop selling",
	"Hàng quà tặng": "Gift",
	"Còn lại {{var0}}": "{{var0}} left",
	"Đã bán {{FlSaleUsedCount}}": "{{FlSaleUsedCount}} sold",
	"Hàng sắp về": "Coming soon",
	"Liên hệ": "Contact",
	"Còn {{stockQuantity}} sản phẩm": "{{stockQuantity}} left",
	"Xem tất cả": "View all",
	"Thương hiệu nổi bật": "Featured brands",
	"Danh mục sản phẩm": "Categories",
	"Sản phẩm dành cho bạn": "Products for you",
	"Chọn ngày nhận hàng": "Select delivery date",
	"Chọn khung giờ": "Select delivery time",
	"Tìm kiếm gần đây": "Recent search",
	"Chọn khu vực nhận hàng": "Select the location",
	"Vui lòng chọn khu vực nhận hàng của bạn": "Please select your location",
	"Tìm kiếm Tỉnh/ Thành phố": "Search Province/City",
	"Không tìm thấy tỉnh thành phố nào !!": "No provice/city is found !!",
	"Khi thay đổi thông tin đơn hàng thanh toán lại, đơn hiện tại sẽ bị hủy. Giá và khuyến mại đơn hàng có thể bị thay đổi. Bạn có chắc chắn muốn thực hiện thao tác này?": "When changing payment order information, current order will be canceled. Order prices and promotions are subject to change. Are you sure you want to perform this action?",
	"Trường hợp muốn thay đổi hình thức thanh toán hoặc các thông tin khác, vui lòng": "If you want to change your payment configuration or other information, please",
	"Bấm vào đây": "Click here",
	"Xem chi tiết": "View detail",
	"Cần thanh toán": "Need to pay",
	"Giao hàng bởi": "Delivered by",
	"Mã vận đơn": "Shipment code",
	"Cung cấp bởi": "Provided by",
	"Combo giảm ~": "Combo discount ~"
};



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-teko-ecommerce-virtual-ca6c4b0024/1/packages/teko-ecommerce/dist/i18n.es.js




var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
const NAMESPACE = "teko-ecommerce";
const t = (keys, options) => {
  const text = i18next["default"].t(keys, __spreadProps(__spreadValues({}, options), { ns: NAMESPACE }));
  return text || keys;
};
const lang = {
  vi: viLang,
  en: enLang
};




/***/ }),

/***/ 865237:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "J": function() { return /* binding */ Col; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);
/* harmony import */ var styled_system__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(479690);
/* harmony import */ var _libs_styled_es_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(855271);




var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const StyledCol = _libs_styled_es_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div */ .Z.div(({ col }) => {
  if (!col) {
    return {
      flex: "1 0 0%",
      minWidth: 0
    };
  }
  return {
    flex: "0 0 auto",
    width: `${col / 12 * 100}%`,
    paddingRight: "0.5rem",
    paddingLeft: "0.5rem"
  };
}, styled_system__WEBPACK_IMPORTED_MODULE_1__.space);
const Col = (_a) => {
  var _b = _a, {
    children,
    col
  } = _b, props = __objRest(_b, [
    "children",
    "col"
  ]);
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledCol, __spreadValues({
    col
  }, props), children);
};




/***/ }),

/***/ 358277:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "W": function() { return /* binding */ Container; }
/* harmony export */ });
/* harmony import */ var styled_system__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(479690);
/* harmony import */ var _libs_styled_es_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(855271);



const Container = _libs_styled_es_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div */ .Z.div(styled_system__WEBPACK_IMPORTED_MODULE_0__.space, ({ fluid }) => {
  const styles = {
    width: "100%",
    marginLeft: "auto",
    marginRight: "auto",
    paddingLeft: "1rem",
    paddingRight: "1rem"
  };
  if (!fluid) {
    styles.maxWidth = "1264px";
  }
  return styles;
});




/***/ }),

/***/ 64201:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "x": function() { return /* binding */ CustomLink; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(535874);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _libs_styled_es_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(855271);
/* harmony import */ var _teko_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(456933);
/* harmony import */ var _teko_utils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(987900);





const Anchor = _libs_styled_es_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"].a */ .Z.a`
  color: unset;
  text-decoration: unset;
`;
const CustomLink = ({
  targetPath,
  children,
  targetType = "_self"
}) => {
  const [href, setHref] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)({
    pathname: targetPath,
    query: {}
  });
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    const init = async () => {
      if (!targetPath)
        return;
      const { pathname, query } = await (0,_teko_utils__WEBPACK_IMPORTED_MODULE_3__/* .resolveTekoPathname */ .K)((0,_teko_utils__WEBPACK_IMPORTED_MODULE_4__/* .getUrlObject */ .Bi)(targetPath));
      setHref({
        pathname: pathname || targetPath,
        query
      });
    };
    init();
  }, [targetPath]);
  if (!targetPath)
    return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, children);
  if (targetPath.startsWith("http"))
    return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Anchor, {
      target: targetType,
      href: targetPath
    }, children);
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
    href,
    as: targetPath,
    passHref: true,
    legacyBehavior: true
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Anchor, {
    target: targetType
  }, children));
};




/***/ }),

/***/ 179185:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "w": function() { return /* binding */ LazyImage; },
/* harmony export */   "x": function() { return /* binding */ WebpImage; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);
/* harmony import */ var _libs_styled_es_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(855271);



const Wrapper = _libs_styled_es_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div */ .Z.div((props) => ({
  maxWidth: "100%",
  position: "relative",
  overflow: "hidden",
  flex: "1 0 auto",
  display: "flex",
  cursor: props.onClick ? "pointer" : "unset",
  zIndex: 0,
  margin: "auto",
  borderRadius: props.borderRadius + "px",
  paddingBottom: props.height ? "" : `${100 / props.aspectRatio}%`,
  border: props.border ? "1px solid #e0e0e0" : "",
  height: props.height ? `${props.height}px !important` : "",
  width: props.width ? `${props.width}px` : "100%",
  backgroundImage: props.thumbnail ? `url("${props.thumbnail}")` : null,
  backgroundSize: props.thumbnail ? "cover" : null,
  contentVisibility: props.height && props.width ? "auto" : null
}));
const WebpImage = ({
  src,
  onClick,
  className,
  height,
  width,
  imageWidth,
  alt = "",
  decoding = "async",
  onLoad
}) => {
  const placeHolder = "data:image/svg+xml;base64, PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNjAiIGhlaWdodD0iMjYwIiB2aWV3Qm94PSIwIDAgMjYwIDI2MCI+CiAgICA8ZyBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPgogICAgICAgIDxwYXRoIGZpbGw9IiNGNkY2RjYiIGQ9Ik0wIDBoMjYwdjI2MEgweiIvPgogICAgICAgIDxwYXRoIGQ9Ik0xMDQgMTA0aDU0djU0aC01NHoiLz4KICAgICAgICA8cGF0aCBmaWxsPSIjQjRCNEI0IiBkPSJNMTUxLjI1IDEwNi4yNWE0LjUgNC41IDAgMCAxIDQuNSA0LjV2NDAuNWE0LjUgNC41IDAgMCAxLTQuNSA0LjVoLTQwLjVhNC41IDQuNSAwIDAgMS00LjUtNC41di00MC41YTQuNSA0LjUgMCAwIDEgNC41LTQuNWg0MC41em0tMTMuNSAxOGwtOSAxMy41TDEyMiAxMzFsLTYuNzUgMTEuMjVoMzEuNWwtOS0xOHptLTEyLjM3NS02Ljc1YTMuMzc1IDMuMzc1IDAgMSAwIDAgNi43NSAzLjM3NSAzLjM3NSAwIDAgMCAwLTYuNzV6Ii8+CiAgICA8L2c+Cjwvc3ZnPgo=";
  let imageUrl = src ? src : placeHolder;
  let altImageUrl = null;
  if (imageUrl && imageUrl.includes("googleusercontent.com")) {
    if (imageWidth || width) {
      imageUrl = `${imageUrl}=w${imageWidth || width}`;
    }
    const checkExt = /=[a-z0-9-]+$/;
    altImageUrl = imageUrl;
    imageUrl = `${imageUrl}${checkExt.test(imageUrl) ? "-rw" : "=rw"}`;
  }
  const imgError = (event) => {
    if (event.target.src !== placeHolder) {
      event.target.src = placeHolder;
    }
    return;
  };
  const imgEle = /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("img", {
    width,
    height,
    onClick,
    className,
    alt,
    onError: imgError,
    src: imageUrl,
    loading: "lazy",
    decoding,
    onLoad
  });
  return altImageUrl ? /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("picture", null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("source", {
    srcSet: imageUrl,
    type: "image/webp"
  }), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("source", {
    srcSet: altImageUrl,
    type: "image/png"
  }), imgEle) : imgEle;
};
const WrapperImage = (0,_libs_styled_es_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(WebpImage)((props) => `
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: ${props.contain ? "contain" : props.cover ? "cover" : ""};
  transition: transform 0.5s;
  &:hover {
    transform: ${props.hover === "zoom" ? "scale(1.05)" : ""};
  }
  `);
const LazyImage = ({
  src,
  onClick,
  className,
  contain = false,
  cover = false,
  aspectRatio = 1,
  height,
  width,
  alt = "",
  border = false,
  hover = "",
  borderRadius = 0,
  thumbnail,
  decoding = "async",
  imageWidth
}) => {
  const imgEle = /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(WrapperImage, {
    hover,
    className: "lazyload",
    contain,
    imageWidth,
    cover,
    alt,
    "data-src": src,
    src,
    decoding
  });
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Wrapper, {
    height,
    width,
    border,
    aspectRatio,
    borderRadius,
    onClick,
    className,
    thumbnail
  }, imgEle);
};




/***/ }),

/***/ 918358:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "t": function() { return /* binding */ BlockHeader; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);
/* harmony import */ var _libs_styled_es_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(855271);
/* harmony import */ var _teko_tracking__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(428247);
/* harmony import */ var _atoms_Col_Col_es_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(865237);
/* harmony import */ var _atoms_CustomLink_CustomLink_es_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(64201);
/* harmony import */ var _configs_theme_es_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(349055);
/* harmony import */ var _atoms_SvgIcon_SvgIcon_es_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(46610);








var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const Wrapper = _libs_styled_es_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div */ .Z.div((props) => `
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px;
  position: relative;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
  border-bottom: ${props.hasDivider ? `1px solid ${props.color}` : ""};
`);
const Title = _libs_styled_es_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div */ .Z.div((props) => `
  color: ${props.color};
  font-size: 20px;
  font-weight: 600;
  line-height: 24px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
`);
const Decor = _libs_styled_es_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div */ .Z.div((props) => `
  position: absolute;
  left: 0;
  margin-top: 2px;
  width: 3px;
  height: 21px;
  background-color:  ${props.color};
`);
const ActionLink = _libs_styled_es_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div */ .Z.div((props) => `
  color: ${props.color} !important;
  --button-icon-color: ${props.color};
  text-decoration: none;
  float: right;
  text-decoration: unset;
  cursor: pointer;
  &:hover {
    ${props.hover === "underline" ? "text-decoration: underline" : `color: ${_configs_theme_es_js__WEBPACK_IMPORTED_MODULE_2__/* .theme.brand.primary */ .r.brand.primary} !important`}
  }
`);
const StyledIcon = (0,_libs_styled_es_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_atoms_SvgIcon_SvgIcon_es_js__WEBPACK_IMPORTED_MODULE_3__/* .SvgIcon */ .l)`
  position: relative;
  top: 2px;
`;
const ActionLinkTitle = _libs_styled_es_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"].span */ .Z.span`
  margin-right: 5px;
`;
const BlockHeader = (_a) => {
  var _b = _a, {
    title,
    actionLink,
    color = "#333",
    hasDivider = false,
    content
  } = _b, props = __objRest(_b, [
    "title",
    "actionLink",
    "color",
    "hasDivider",
    "content"
  ]);
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Wrapper, __spreadValues({
    hasDivider,
    color
  }, props), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_atoms_Col_Col_es_js__WEBPACK_IMPORTED_MODULE_4__/* .Col */ .J, null, title && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Decor, {
    color
  }), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Title, {
    color,
    className: "title"
  }, title))), content && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_atoms_Col_Col_es_js__WEBPACK_IMPORTED_MODULE_4__/* .Col */ .J, {
    col: actionLink ? 9.8 : 10.95
  }, content), actionLink && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", __spreadValues({}, actionLink.regionName && (0,_teko_tracking__WEBPACK_IMPORTED_MODULE_5__/* .getTrackingData */ .O5)({
    isTrackContent: true,
    regionName: actionLink.regionName,
    contentName: actionLink.contentName,
    target: actionLink.target
  })), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_atoms_CustomLink_CustomLink_es_js__WEBPACK_IMPORTED_MODULE_6__/* .CustomLink */ .x, {
    targetPath: actionLink.href
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(ActionLink, {
    color: actionLink.color || "#f1f0f1",
    hover: actionLink.hover
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(ActionLinkTitle, null, actionLink.title), !actionLink.hideIcon && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledIcon, {
    name: "chevron-forward",
    size: 13
  })))));
};




/***/ }),

/***/ 797864:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Card; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);
/* harmony import */ var styled_system__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(479690);
/* harmony import */ var _libs_styled_es_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(855271);




var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const StyledCard = _libs_styled_es_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div */ .Z.div(({ theme, withPadding }) => `
  border-radius: 8px;
  background-color: ${theme.colors.white};
  position: relative;
  ${withPadding ? "padding: .5rem;" : ""}
`, styled_system__WEBPACK_IMPORTED_MODULE_1__.space);
const CardHeader = _libs_styled_es_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div */ .Z.div``;
const CardBody = _libs_styled_es_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div */ .Z.div``;
const CardFooter = _libs_styled_es_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div */ .Z.div``;
const Card = react__WEBPACK_IMPORTED_MODULE_0__.forwardRef((_a, ref) => {
  var _b = _a, { children, header, footer, withPadding } = _b, props = __objRest(_b, ["children", "header", "footer", "withPadding"]);
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledCard, __spreadValues({
    ref,
    withPadding
  }, props), header && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(CardHeader, {
    className: "card-header"
  }, header), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(CardBody, {
    className: "card-body"
  }, children), footer && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(CardFooter, {
    className: "card-footer"
  }, footer));
});
Card.displayName = "Card";




/***/ }),

/***/ 665207:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "I": function() { return /* binding */ HeadSection; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(561261);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(891987);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(979894);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _contexts__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(684443);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}




const HeadSection = (param)=>{
    let { title , metaTitle , description , keywords , image , canonical , prevHref , nextHref , noindex =false , links  } = param;
    const { meta  } = (0,_contexts__WEBPACK_IMPORTED_MODULE_3__/* .useTenantConfig */ .Wx)();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_2___default()), {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                children: title || meta.title
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "title",
                content: metaTitle || title || meta.title
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:title",
                content: metaTitle || title || meta.title
            }),
            description !== false && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "description",
                content: description || meta.description
            }),
            keywords && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "keywords",
                content: keywords
            }),
            description !== false && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:description",
                content: description || meta.description
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "image",
                content: image || meta.image
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:image",
                content: image || meta.image
            }),
            noindex ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "robots",
                content: "noindex, nofollow"
            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "robots",
                content: "index, follow"
            }),
            canonical && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                rel: "canonical",
                href: canonical
            }),
            prevHref && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                rel: "prev",
                href: prevHref
            }),
            nextHref && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                rel: "next",
                href: nextHref
            }),
            links === null || links === void 0 ? void 0 : links.map((attrs)=>Object.keys(attrs).length && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", _objectSpread({}, attrs))),
            meta.dcmaVerificationContent && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "dmca-site-verification",
                content: meta.dcmaVerificationContent
            })
        ]
    });
};


/***/ }),

/***/ 235904:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "b": function() { return /* binding */ PreLoad; },
/* harmony export */   "g": function() { return /* binding */ Loading; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(561261);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(891987);
/* harmony import */ var _contexts_GlobalDataContext__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(684443);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(80912);




const Loading = (param)=>{
    let { isLoading , children  } = param;
    var ref;
    const { logo  } = (0,_contexts_GlobalDataContext__WEBPACK_IMPORTED_MODULE_2__/* .useGlobalData */ .U5)();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_3__/* .Loading */ .g, {
        isLoading: isLoading,
        logo: (ref = (logo === null || logo === void 0 ? void 0 : logo.loading) || (logo === null || logo === void 0 ? void 0 : logo.lite)) === null || ref === void 0 ? void 0 : ref.path,
        children: children
    });
};
const PreLoad = (param)=>{
    let { isLoading , height  } = param;
    var ref;
    const { logo  } = (0,_contexts_GlobalDataContext__WEBPACK_IMPORTED_MODULE_2__/* .useGlobalData */ .U5)();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_3__/* .Loading */ .g, {
        isLoading: isLoading,
        style: {
            height: typeof height === "number" ? "".concat(height, "px") : height
        },
        logo: (ref = (logo === null || logo === void 0 ? void 0 : logo.loading) || (logo === null || logo === void 0 ? void 0 : logo.lite)) === null || ref === void 0 ? void 0 : ref.path
    });
};


/***/ }),

/***/ 339559:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "BannerSlides": function() { return /* binding */ BannerSlides; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(561261);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(212951);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(816519);
/* harmony import */ var _teko_teko_ecommerce__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(788925);
/* harmony import */ var _teko_tracking__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(428247);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(891987);
/* harmony import */ var _helpers__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(788813);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    const data = _taggedTemplateLiteral([
        "\n  .glide__bullets--override {\n    bottom: 7em;\n  }\n\n  .glide__bullet--active {\n    background-color: ",
        ";\n  }\n\n  .glide__slide a {\n    width: 100%;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = _taggedTemplateLiteral([
        "\n  display: flex;\n  justify-content: center;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}






const serverless = (0,_helpers__WEBPACK_IMPORTED_MODULE_2__/* .isServerless */ .ep)();
const BannerSlides = (param)=>{
    let { banners , imageWidth =1920 , imageHeight =566 , sliderRef , prioritized , showControl =false , displayNewLayout  } = param;
    if (!banners.length) return null;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(StyledGlide, {
        ref: sliderRef,
        perView: 1,
        autoplay: 3000,
        type: "carousel",
        showControl: showControl,
        displayNewLayout: displayNewLayout,
        showBullet: true,
        children: banners.map((banner, index)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(SlideWrapper, _objectSpreadProps(_objectSpread({
                className: "glide__slide"
            }, (0,_teko_tracking__WEBPACK_IMPORTED_MODULE_3__/* .getTrackingData */ .O5)({
                isTrackContent: true,
                regionName: "topSliderBannerHomepage",
                contentName: banner.campaignName,
                target: banner.targetPath,
                index
            })), {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_teko_ecommerce__WEBPACK_IMPORTED_MODULE_4__/* .EnhancedImage */ .N, {
                    googleImageParams: {
                        width: imageWidth
                    },
                    link: {
                        href: serverless && banner.targetPath && banner.targetPath.startsWith(location.origin) ? banner.targetPath.replace(location.origin, "") : banner.targetPath
                    },
                    objectFit: "cover",
                    width: "100%",
                    height: imageHeight || 566,
                    src: banner.image,
                    thumbnail: banner.thumbnail,
                    alt: banner.campaignName,
                    lazy: index === 0 ? false : true,
                    fetchPriority: index === 0 ? prioritized ? "high" : "auto" : "low"
                })
            }), index))
    });
};
const StyledGlide = (0,_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_5__["default"])(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_6__/* .Glide */ .A)(_templateObject(), (param)=>{
    let { theme  } = param;
    return theme.colors.primary;
});
const SlideWrapper = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_5__["default"].div(_templateObject1());


/***/ }),

/***/ 759135:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "f": function() { return /* binding */ LandingPage; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(561261);
/* harmony import */ var i18n__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(634655);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(891987);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(35304);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _teko_ecommerce__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(980424);
/* harmony import */ var _teko_ui__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(855271);
/* harmony import */ var _teko_ui__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(358277);
/* harmony import */ var _teko_ui__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(179185);
/* harmony import */ var _teko_ui__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(797864);
/* harmony import */ var _teko_ui__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(918358);
/* harmony import */ var hooks__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(684443);
/* harmony import */ var hooks__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(702070);
/* harmony import */ var hooks__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(700074);
/* harmony import */ var hooks__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(88837);
/* harmony import */ var components_desktop_organisms_BannerSlides__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(339559);
/* harmony import */ var _teko_teko_ecommerce__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(414562);
/* harmony import */ var _teko_tracking__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(428247);
/* harmony import */ var components_HeadSection__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(665207);
/* harmony import */ var _teko_utils__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(456933);
/* harmony import */ var _teko_utils__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(987900);
/* harmony import */ var contexts__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(266521);
/* harmony import */ var components_Loading__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(235904);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    const data = _taggedTemplateLiteral([
        "\n  background-color: #fff;\n  margin: 2rem auto;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = _taggedTemplateLiteral([
        "\n  background-color: #fff;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    const data = _taggedTemplateLiteral([
        "\n  padding: 8px 16px 16px 0;\n  text-align: center;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    const data = _taggedTemplateLiteral([
        "\n  width: 60%;\n  cursor: pointer;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    const data = _taggedTemplateLiteral([
        "\n  margin: 0;\n  padding: 8rem;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}














const Wrapper = (0,_teko_ui__WEBPACK_IMPORTED_MODULE_3__/* .styled */ .z)(_teko_ui__WEBPACK_IMPORTED_MODULE_4__/* .Container */ .W)(_templateObject());
const BannerProductGroup = _teko_ui__WEBPACK_IMPORTED_MODULE_3__/* .styled.div */ .z.div(_templateObject1());
const ImageWrapper = _teko_ui__WEBPACK_IMPORTED_MODULE_3__/* .styled.div */ .z.div(_templateObject2());
const StyledImage = (0,_teko_ui__WEBPACK_IMPORTED_MODULE_3__/* .styled */ .z)(_teko_ui__WEBPACK_IMPORTED_MODULE_5__/* .WebpImage */ .x)(_templateObject3());
const StyledNoProductsFound = (0,_teko_ui__WEBPACK_IMPORTED_MODULE_3__/* .styled */ .z)(_teko_ecommerce__WEBPACK_IMPORTED_MODULE_6__/* .NoProductsFound */ .H)(_templateObject4());
const LandingPage = ()=>{
    const router = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
    const { baseDomain , canonicalDomain  } = (0,hooks__WEBPACK_IMPORTED_MODULE_7__/* .useTenantConfig */ .Wx)();
    const { result: allMenuItems , isLoading  } = (0,hooks__WEBPACK_IMPORTED_MODULE_8__/* .useMenuItems */ .JR)("landing-banner-product-".concat(router.query.id));
    const { banners , loading: bannersLoading  } = (0,hooks__WEBPACK_IMPORTED_MODULE_9__/* .useBanners */ .U)("landing-banner-".concat(router.query.id));
    const showPageNotFound = !isLoading && !bannersLoading && !allMenuItems.parents.length && !banners.length;
    const { restoreScrollPos  } = (0,contexts__WEBPACK_IMPORTED_MODULE_10__/* .useRouterEffect */ .e)();
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        if ("scrollRestoration" in window.history) {
            restoreScrollPos(router.asPath);
        }
    }, [
        banners.length,
        router
    ]);
    const onClickBanner = async (urlType, targetPath, url)=>{
        const href = url ? url : targetPath && targetPath.startsWith("/") ? targetPath : null;
        if (href) {
            const { pathname , query  } = await (0,_teko_utils__WEBPACK_IMPORTED_MODULE_11__/* .resolveTekoPathname */ .K)((0,_teko_utils__WEBPACK_IMPORTED_MODULE_12__/* .getUrlObject */ .Bi)(href));
            router.push({
                pathname: pathname || href,
                query
            }, href).then(()=>window.scrollTo(0, 0));
            return;
        }
        if (urlType === "rewrite") {
            router.push({
                pathname: "/search",
                search: "?router=productListing&".concat(targetPath)
            }).then(()=>window.scrollTo(0, 0));
            return;
        }
        window.location.href = targetPath;
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(Wrapper, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_HeadSection__WEBPACK_IMPORTED_MODULE_13__/* .HeadSection */ .I, {
                canonical: "".concat(canonicalDomain || baseDomain, "/landing/").concat(router.query.id)
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Loading__WEBPACK_IMPORTED_MODULE_14__/* .Loading */ .g, {
                isLoading: isLoading || bannersLoading,
                children: showPageNotFound ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(StyledNoProductsFound, {
                    text: (0,i18n__WEBPACK_IMPORTED_MODULE_15__.t)("Trang kh\xf4ng tồn tại"),
                    show: true
                }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                    children: [
                        !!(banners === null || banners === void 0 ? void 0 : banners.length) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_desktop_organisms_BannerSlides__WEBPACK_IMPORTED_MODULE_16__.BannerSlides, {
                            banners: banners,
                            imageWidth: 1232
                        }),
                        !!allMenuItems.parents.length && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(BannerProductGroup, {
                            children: allMenuItems.parents.map((item)=>{
                                var ref;
                                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
                                    children: [
                                        item.icon && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ImageWrapper, _objectSpreadProps(_objectSpread({}, (0,_teko_tracking__WEBPACK_IMPORTED_MODULE_17__/* .getTrackingData */ .O5)({
                                            isTrackContent: true,
                                            regionName: "landingBannerProducts",
                                            contentName: item.name
                                        })), {
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(StyledImage, {
                                                width: 1232,
                                                onClick: ()=>onClickBanner(item.urlType, item.targetPath, item.url),
                                                src: item.icon,
                                                alt: item.name
                                            })
                                        })),
                                        !!((ref = item.children) === null || ref === void 0 ? void 0 : ref.length) ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(LandingProductCarousel, {
                                            slug: item.children[0].urlType === "rewrite" ? item.children[0].url || "" : "",
                                            title: item.children[0].name,
                                            url: item.children[0].url || ""
                                        }) : null
                                    ]
                                }, item.id);
                            })
                        })
                    ]
                })
            })
        ]
    });
};
const LandingProductCarousel = (param)=>{
    let { slug , title , url  } = param;
    const convertSearchParam = {
        slug: slug
    };
    const { result , isLoading  } = (0,hooks__WEBPACK_IMPORTED_MODULE_18__/* .useSearch */ .Rx)(convertSearchParam);
    if (!result.products.length && !isLoading) return null;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ui__WEBPACK_IMPORTED_MODULE_19__/* .Card */ .Z, {
        header: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ui__WEBPACK_IMPORTED_MODULE_20__/* .BlockHeader */ .t, {
            hasDivider: true,
            title: title,
            actionLink: {
                title: "Xem tất cả",
                href: url,
                color: "#333",
                hover: "underline"
            }
        }),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_teko_ecommerce__WEBPACK_IMPORTED_MODULE_21__/* .ProductCarousel */ .G, {
            spaceBetween: 12,
            productsPerRow: 5,
            products: result.products,
            regionName: "landingProductBlocks"
        })
    });
};


/***/ }),

/***/ 101763:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Q": function() { return /* binding */ buildTreeCategories; },
/* harmony export */   "q": function() { return /* binding */ convertMegaMenuItem; }
/* harmony export */ });
/* harmony import */ var _teko_discovery__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(875663);
/* harmony import */ var ___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(788813);
/* harmony import */ var _teko_slug__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(93512);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}



const convertUrl = (targetPath, urlType, isTargetBlank)=>{
    if (!targetPath) {
        return undefined;
    }
    if (urlType === "rewrite") {
        return {
            href: "/search?router=productListing&" + targetPath,
            target: isTargetBlank ? "_blank" : "_self"
        };
    }
    return {
        href: targetPath,
        target: isTargetBlank ? "_blank" : "_self"
    };
};
const getMenuItemUrl = (item)=>{
    const { isTargetBlank , url , targetPath , urlType  } = item || {};
    const target = isTargetBlank ? "_blank" : "_self";
    const href = url || (urlType === "rewrite" ? "/search?router=productListing&" + targetPath : targetPath);
    return {
        href,
        target
    };
};
const getUrl = (item)=>{
    const { isTargetBlank , url  } = item || {};
    const target = isTargetBlank ? "_blank" : "_self";
    if (!url) return null;
    return {
        href: url,
        target
    };
};
const convertUrlParamsToObject = (urlParams)=>{
    const urlParamsArray = Array.from(urlParams);
    return urlParamsArray.reduce((acc, cur)=>_objectSpreadProps(_objectSpread({}, acc), {
            [cur[0]]: cur[1]
        }), {});
};
const computeBlockPageUrl = (menu)=>{
    var ref;
    if (!menu.targetPath || menu.urlType !== "rewrite") {
        return null;
    }
    const menuConfig = menu.configs;
    const targetFilterParams = convertUrlParamsToObject(new URLSearchParams(menu.targetPath));
    // targetPath has only 1 filter config
    if (((ref = Object.keys(targetFilterParams)) === null || ref === void 0 ? void 0 : ref.length) === 1) {
        var ref1;
        const filterKey = Object.keys(targetFilterParams)[0];
        const filterValue = ((ref1 = menuConfig[filterKey]) === null || ref1 === void 0 ? void 0 : ref1.length) === 1 ? menuConfig[filterKey][0] : null;
        if (!filterValue) {
            return null;
        }
        switch(filterKey){
            case "brands":
                return {
                    href: {
                        pathname: "/brands/[brandId]",
                        query: {
                            brandId: filterValue
                        }
                    },
                    target: menu.isTargetBlank ? "_blank" : "_self",
                    as: {
                        pathname: (0,___WEBPACK_IMPORTED_MODULE_0__/* .buildSlugUrl */ .hH)(_teko_discovery__WEBPACK_IMPORTED_MODULE_1__/* .PageTypeEnum.BRAND */ .DZ.BRAND, menu.name, filterValue)
                    },
                    shallow: true
                };
            case "masterCategoryIds":
                return {
                    href: {
                        pathname: "/block-categories/[categoryId]",
                        query: {
                            categoryId: filterValue
                        }
                    },
                    target: menu.isTargetBlank ? "_blank" : "_self",
                    as: (0,___WEBPACK_IMPORTED_MODULE_0__/* .buildSlugUrl */ .hH)(_teko_discovery__WEBPACK_IMPORTED_MODULE_1__/* .PageTypeEnum.CATEGORY */ .DZ.CATEGORY, menu.name, filterValue) || undefined,
                    shallow: true
                };
            case "sellerIds":
                return {
                    href: {
                        pathname: "/sellers/[sellerId]",
                        query: {
                            sellerId: filterValue
                        }
                    },
                    target: menu.isTargetBlank ? "_blank" : "_self",
                    as: (0,___WEBPACK_IMPORTED_MODULE_0__/* .buildSlugUrl */ .hH)(_teko_discovery__WEBPACK_IMPORTED_MODULE_1__/* .PageTypeEnum.SELLER */ .DZ.SELLER, menu.name, filterValue) || undefined,
                    shallow: true
                };
            case "categories":
                return {
                    href: {
                        pathname: "/seller-categories/[sellerCategoryId]",
                        query: {
                            sellerCategoryId: filterValue
                        }
                    },
                    target: menu.isTargetBlank ? "_blank" : "_self",
                    as: "/".concat((0,_teko_slug__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(menu.name), "-scat.").concat(filterValue),
                    shallow: true
                };
            default:
                return null;
        }
    }
    return null;
};
const convertMegaMenuItem = (item)=>{
    var ref, ref1, ref2, ref3, ref4;
    return {
        id: item.id,
        name: item.name,
        icon: item.icon,
        link: getUrl(item) || computeBlockPageUrl(item) || getMenuItemUrl(item),
        banner: !!((ref = item.banners) === null || ref === void 0 ? void 0 : ref.length) ? {
            src: (ref1 = item.banners[0]) === null || ref1 === void 0 ? void 0 : ref1.image,
            hoverEffect: "zoom",
            link: convertUrl((ref2 = item.banners[0]) === null || ref2 === void 0 ? void 0 : ref2.targetPath, (ref3 = item.banners[0]) === null || ref3 === void 0 ? void 0 : ref3.urlType)
        } : undefined,
        children: ((ref4 = item.children) === null || ref4 === void 0 ? void 0 : ref4.map(convertMegaMenuItem)) || []
    };
};
const getValidBanners = (banners)=>{
    return banners.filter((banner)=>{
        if (!banner.isActive) return false;
        const currentTime = new Date().getTime();
        if (banner === null || banner === void 0 ? void 0 : banner.startDate) {
            if (!(banner === null || banner === void 0 ? void 0 : banner.endDate)) {
                return currentTime >= banner.startDate * 1000;
            }
            return banner.startDate * 1000 <= currentTime && banner.endDate * 1000 >= currentTime;
        }
        if (banner === null || banner === void 0 ? void 0 : banner.endDate) {
            return currentTime <= banner.endDate * 1000;
        }
        return true;
    });
};
const buildTreeCategories = (menuItems)=>{
    const rootMenuItems = menuItems.filter((param)=>{
        let { parentId  } = param;
        return !parentId;
    });
    const buildMenuItem = (root)=>{
        const children = menuItems.filter((param)=>{
            let { parentId  } = param;
            return parentId === root.id;
        });
        return _objectSpreadProps(_objectSpread({}, root), {
            banners: getValidBanners(root.banners || []),
            children: children.map(buildMenuItem)
        });
    };
    return rootMenuItems.map((root)=>buildMenuItem(root));
};


/***/ }),

/***/ 702070:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "JR": function() { return /* binding */ useMenuItems; },
/* harmony export */   "p6": function() { return /* binding */ useMenuItemById; }
/* harmony export */ });
/* unused harmony export getMenuItems */
/* harmony import */ var swr__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(859676);
/* harmony import */ var _helpers__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(101763);
/* harmony import */ var contexts__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(643015);
/* harmony import */ var _teko_log__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(420577);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}




// TODO: temporary function, to avoid having to copy it
// will clean it up later.
// ideally move inside discovery method .getMenuItems
const getMenuItems = async (discoveryService, zone)=>{
    try {
        var ref, ref1;
        const data = await discoveryService.getMenuItems(zone);
        return {
            menuItems: (data === null || data === void 0 ? void 0 : (ref = data.result) === null || ref === void 0 ? void 0 : ref.menuItems) || [],
            parents: (0,_helpers__WEBPACK_IMPORTED_MODULE_2__/* .buildTreeCategories */ .Q)((data === null || data === void 0 ? void 0 : (ref1 = data.result) === null || ref1 === void 0 ? void 0 : ref1.menuItems) || [])
        };
    } catch (er) {
        _teko_log__WEBPACK_IMPORTED_MODULE_1__/* .logger.error */ .k.error(er);
        return {
            menuItems: [],
            parents: []
        };
    }
};
const useMenuItems = function(zone) {
    let defaultValue = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
        menuItems: [],
        parents: []
    };
    const { discoveryService  } = (0,contexts__WEBPACK_IMPORTED_MODULE_3__/* .useServices */ .Su)();
    const { data , error , isValidating  } = (0,swr__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP)([
        "/menu-items",
        zone
    ], async (_, zone)=>await getMenuItems(discoveryService, zone), {
        fallbackData: _objectSpread({}, defaultValue),
        onError: (e)=>{
            _teko_log__WEBPACK_IMPORTED_MODULE_1__/* .logger.error */ .k.error("getMenuItems error:", e);
            return defaultValue;
        }
    });
    return {
        result: data || {
            menuItems: [],
            parents: []
        },
        isLoading: !zone ? false : !error && !data || isValidating,
        isError: error
    };
};
const useMenuItemById = (categoryId)=>{
    const { discoveryService  } = (0,contexts__WEBPACK_IMPORTED_MODULE_3__/* .useServices */ .Su)();
    const url = "/menu-item/".concat(categoryId);
    const { data , error  } = (0,swr__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP)(categoryId ? url : null, async ()=>{
        return await discoveryService.getMenuItemById(categoryId);
    });
    return {
        result: data === null || data === void 0 ? void 0 : data.result,
        isLoading: !categoryId ? false : !error && !data,
        isError: error
    };
};


/***/ }),

/***/ 77322:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "g": function() { return /* binding */ trackViewProductDetail; },
/* harmony export */   "u": function() { return /* binding */ trackViewProductList; }
/* harmony export */ });
/* harmony import */ var _meta_pixel_es_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(437618);


const trackViewProductDetail = (product) => {
  var _a, _b;
  (_a = window.dataLayer) == null ? void 0 : _a.push({
    event: "viewDetail",
    ecommerce: {
      detail: {
        products: [product]
      }
    }
  });
  if (!!window.fbq && !!((_b = window.env) == null ? void 0 : _b.FB_PIXEL_ID)) {
    const value = typeof product.price === "number" ? product.price : parseFloat(product.price) || 0;
    (0,_meta_pixel_es_js__WEBPACK_IMPORTED_MODULE_0__/* .trackMetaPixelViewContent */ .SI)({
      content_ids: [product.sku],
      content_category: product.category || "",
      content_name: product.name || "",
      content_type: "product",
      contents: [{ id: product.sku, quantity: 1 }],
      currency: "VND",
      value
    });
  }
};
const trackViewProductList = (products) => {
  var _a;
  (_a = window.dataLayer) == null ? void 0 : _a.push({
    event: "viewListing",
    ecommerce: {
      impressions: products
    }
  });
};




/***/ })

}]);